export const CATEGORIES = [
  { slug: "electronics", label: "Electronics", subtitle: "Audio, cameras, TVs & smart devices" },
  { slug: "phones", label: "Phones & Accessories", subtitle: "Cases, chargers, screens & wearables" },
  { slug: "computers", label: "Computers & Gaming", subtitle: "Laptops, components, consoles & peripherals" },
  { slug: "appliances", label: "Appliances", subtitle: "Kitchen & home appliances" },
  { slug: "home", label: "Home & Living", subtitle: "Furniture, décor & kitchenware" },
  { slug: "garden", label: "Garden & Outdoor", subtitle: "Plants, outdoor furniture & camping" },
  { slug: "fashion", label: "Fashion", subtitle: "Clothing & apparel for every style" },
  { slug: "shoes", label: "Shoes & Footwear", subtitle: "Sneakers, formal, sandals & boots" },
  { slug: "bags", label: "Bags & Luggage", subtitle: "Handbags, backpacks & travel gear" },
  { slug: "jewelry", label: "Jewelry & Watches", subtitle: "Fine jewelry, watches & accessories" },
  { slug: "beauty", label: "Beauty", subtitle: "Skincare, makeup & fragrance" },
  { slug: "health", label: "Health & Wellness", subtitle: "Supplements, fitness gear & medical devices" },
  { slug: "baby", label: "Baby & Kids", subtitle: "Strollers, clothing, feeding & nursery" },
  { slug: "toys", label: "Toys & Games", subtitle: "Play, puzzles & hobbies" },
  { slug: "sports", label: "Sports & Fitness", subtitle: "Equipment, apparel & outdoor sport" },
  { slug: "automotive", label: "Automotive & Parts", subtitle: "Car accessories, spares & motorbike parts" },
  { slug: "tools", label: "Tools & Industrial", subtitle: "Hardware, machinery & building materials" },
  { slug: "agriculture", label: "Agriculture & Food Production", subtitle: "Seeds, farm inputs & processing" },
  { slug: "office", label: "Office & School", subtitle: "Stationery, supplies & business equipment" },
  { slug: "grocery", label: "Grocery", subtitle: "Food, drinks & everyday essentials" },
  { slug: "pets", label: "Pets", subtitle: "Food, toys & care for every animal" },
  { slug: "books", label: "Books", subtitle: "Fiction, education & learning" },
  { slug: "music", label: "Music & Instruments", subtitle: "Instruments & studio gear" },
  { slug: "art", label: "Art & Collectibles", subtitle: "Crafts, prints & memorabilia" },
  { slug: "digital", label: "Services & Digital", subtitle: "Digital products, templates & gift cards" },
  { slug: "other", label: "Everything Else", subtitle: "Anything that doesn't fit elsewhere" },
];

export const CATEGORY_SLUGS = CATEGORIES.map((c) => c.slug);
export const categoryLabel = (slug) =>
  CATEGORIES.find((c) => c.slug === slug)?.label || slug;
